/* Khan Mall — cart drawer: express checkout, Shop Pay + Google Pay + Apple Pay.
 *
 * Why this exists: the Avada drawer hosts Shopify's
 * <shopify-accelerated-checkout-cart>, which renders one fixed-height row per
 * wallet in its wallet-configs attribute. Those rows live inside the
 * component's shadow DOM, so theme CSS cannot collapse the rows of hidden
 * wallets — hiding them with display:none leaves ~186px of dead space on
 * mobile. Trimming wallet-configs to the approved wallets before the
 * component renders means the extra rows are never created. No native
 * Shopify or Avada setting offers per-placement wallet selection, so this
 * drawer-scoped trim is the only way to choose drawer wallets without
 * touching checkout or product-page wallets.
 *
 * Strictly scoped to the Avada drawer's express section; product-page and
 * cart-page accelerated checkout are never touched.
 */
(function () {
  'use strict';
  var DRAWER_SELECTOR = '.AOV-CartDrawer-Footer__ExpressPayments';
  var TAG = 'shopify-accelerated-checkout-cart';

  var KEPT_WALLETS = ['shop_pay', 'google_pay', 'apple_pay'];

  function isKeptWallet(cfg) {
    var n = String((cfg && cfg.name) || '').toLowerCase().replace(/-/g, '_');
    return KEPT_WALLETS.indexOf(n) !== -1;
  }

  function trim(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.tagName.toLowerCase() !== TAG) return;
    if (!el.closest(DRAWER_SELECTOR)) return;
    var raw = el.getAttribute('wallet-configs');
    if (!raw) return;
    var configs;
    try {
      configs = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!Array.isArray(configs)) return;
    var kept = configs.filter(isKeptWallet);
    if (kept.length === 0 || kept.length >= configs.length) return;
    var next = document.createElement(TAG);
    for (var i = 0; i < el.attributes.length; i++) {
      var a = el.attributes[i];
      if (a.name.toLowerCase() !== 'wallet-configs') next.setAttribute(a.name, a.value);
    }
    next.setAttribute('wallet-configs', JSON.stringify(kept));
    while (el.firstChild) next.appendChild(el.firstChild);
    if (el.parentNode) el.parentNode.replaceChild(next, el);
  }

  function sweep(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName.toLowerCase() === TAG) {
      trim(node);
      return;
    }
    var els = node.querySelectorAll(TAG);
    for (var i = 0; i < els.length; i++) trim(els[i]);
  }

  function sweepDocument() {
    sweep(document.documentElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweepDocument);
  } else {
    sweepDocument();
  }

  if (window.MutationObserver) {
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) sweep(added[j]);
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
